var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getCatalogListWithProductCount, getCustomerListWithMainContact, getB2BCompaniesAction, singleCompanyDataService } from "../../reduxStore/actions/salesRepDataAction";
import store from "../../reduxStore/store";
import { isLoading } from "../../services/behaviorSubjectService";
import { CommonMethods } from "./CommonMethods";
export function MyCompanyBL() {
    var _this = this;
    var _a, _b, _c;
    var _d = CommonMethods(), getDefaultCompanyDetails = _d.getDefaultCompanyDetails, mapAddress = _d.mapAddress;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _e = useState(""), activeCompanyString = _e[0], setActiveCompanyString = _e[1];
    var _f = useState(""), activeLocationString = _f[0], setActiveLocationString = _f[1];
    var _g = useState(false), isClicked = _g[0], setIsClicked = _g[1];
    var HeaderNames = [
        {
            id: "ClientName",
            label: t("CreateOrder_Company"),
            inlineCSS: { width: "80%" },
        },
        {
            id: "ClientName",
            label: t("Create_Order_MainContact"),
            inlineCSS: { width: "20%" },
        },
    ];
    // Company list is loaded via data=56 on mount (GetB2BCompanyDetails no longer populated from data=1)
    var _h = useState("asc"), orderType = _h[0], setOrderType = _h[1];
    var _j = useState("name"), byColumnName = _j[0], setByColumnName = _j[1];
    var _k = useState(""), filterState = _k[0], setFilterState = _k[1];
    var _l = useState([]), companyArray = _l[0], setCompanyArray = _l[1];
    /** True until first page is resolved from Redux cache or data=56 (avoids empty-state flash while API runs) */
    var _m = useState(true), isCompanyListLoading = _m[0], setIsCompanyListLoading = _m[1];
    var _o = useState(false), loadingDisabled = _o[0], setLoadingDisabled = _o[1];
    var _p = useState(getDefaultCompanyDetails()), singleCompanyDetails = _p[0], setSingleCompanyDetails = _p[1];
    var _q = useState(""), CompanyCustomerOrderingRoleId = _q[0], setCompanyCustomerOrderingRoleId = _q[1];
    // Pagination & search state — mirrors MyCustomerBL pattern
    var _r = useState(false), isSearching = _r[0], setIsSearching = _r[1];
    var _s = useState(false), isPagination = _s[0], setIsPagination = _s[1];
    var _t = useState(""), currentSearchTerm = _t[0], setCurrentSearchTerm = _t[1];
    var _u = useState({
        endCursor: "",
        startCursor: "",
        hasNext: false,
        hasPrevious: false,
    }), paginationState = _u[0], setPaginationState = _u[1];
    var selectFeatures = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.select;
    var tempOrderType = "";
    isLoading.subscribe(function (data) {
        if (data !== loadingDisabled)
            setLoadingDisabled(data);
    });
    useEffect(function () {
        sortHeaderData("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        getCustomerDetails();
    }, []);
    var getCustomerDetails = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // need to update the redux state of customer list for not calling multile times.
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(getCustomerListWithMainContact("1"))];
                case 1:
                    _a.sent();
                    setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(getCatalogListWithProductCount("2"))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, 1000);
                    isLoading.next(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var sortHeaderData = function (columnName) {
        if (columnName === byColumnName) {
            tempOrderType = orderType === "asc" ? "desc" : "asc";
            setOrderType(tempOrderType);
        }
        else {
            tempOrderType = "asc";
            setOrderType(tempOrderType);
            setByColumnName(columnName);
        }
        sortColumnData(columnName);
    };
    var sortColumnData = function (columnName) {
        var aTemp, bTemp;
        var sorted = __spreadArray([], (companyArray || []), true);
        if (tempOrderType === "asc") {
            sorted.sort(function (a, b) {
                if (typeof a[columnName] && typeof b[columnName] === "string") {
                    if (a[columnName] !== undefined && a[columnName] !== null && a[columnName] !== "" && b[columnName] !== undefined && b[columnName] !== null && b[columnName] !== "") {
                        aTemp = a[columnName].toLowerCase();
                        bTemp = b[columnName].toLowerCase();
                    }
                    return aTemp > bTemp ? 1 : -1;
                }
                else {
                    return a[columnName] - b[columnName];
                }
            });
        }
        else {
            sorted.sort(function (a, b) {
                if (typeof a[columnName] && typeof b[columnName] === "string") {
                    if (a[columnName] !== undefined && a[columnName] !== null && a[columnName] !== "" && b[columnName] !== undefined && b[columnName] !== null && b[columnName] !== "") {
                        aTemp = a[columnName].toLowerCase();
                        bTemp = b[columnName].toLowerCase();
                    }
                    return aTemp < bTemp ? 1 : -1;
                }
                else {
                    return b[columnName] - a[columnName];
                }
            });
        }
        setCompanyArray(sorted);
    };
    var applyFilter = function (e) {
        setFilterState(e.target.value);
        var filtered = (companyArray || []).filter(function (data) {
            var _a, _b, _c, _d, _e, _f;
            var companyName = ((_a = data === null || data === void 0 ? void 0 : data.companyName) !== null && _a !== void 0 ? _a : "").trim() ? data === null || data === void 0 ? void 0 : data.companyName : (_b = data === null || data === void 0 ? void 0 : data.locationMainContactName) !== null && _b !== void 0 ? _b : "";
            return (((_c = companyName === null || companyName === void 0 ? void 0 : companyName.toLowerCase()) === null || _c === void 0 ? void 0 : _c.includes(e.target.value.toLowerCase())) ||
                ((data === null || data === void 0 ? void 0 : data.companyName) !== undefined && (data === null || data === void 0 ? void 0 : data.companyName) !== null && (data === null || data === void 0 ? void 0 : data.companyName) !== "" && ((_e = (_d = data === null || data === void 0 ? void 0 : data.companyName) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === null || _e === void 0 ? void 0 : _e.includes((_f = e.target.value) === null || _f === void 0 ? void 0 : _f.toLowerCase()))));
        });
        setCompanyArray(filtered);
    };
    var updateLocalCompanyState = function (data) {
        var _a, _b, _c, _d;
        if (data && Array.isArray(data.companies)) {
            setCompanyArray(data.companies);
            setPaginationState({
                endCursor: (_a = data.endCursor) !== null && _a !== void 0 ? _a : "",
                startCursor: (_b = data.startCursor) !== null && _b !== void 0 ? _b : "",
                hasNext: (_c = data.hasNext) !== null && _c !== void 0 ? _c : false,
                hasPrevious: (_d = data.hasPrevious) !== null && _d !== void 0 ? _d : false,
            });
        }
    };
    var fetchCompanies = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, getB2BCompaniesAction({
                        batchSize: 50,
                        searchQuery: (_a = params.searchQuery) !== null && _a !== void 0 ? _a : "",
                        isNextPage: (_b = params.isNextPage) !== null && _b !== void 0 ? _b : true,
                        endCursor: (_c = params.endCursor) !== null && _c !== void 0 ? _c : "",
                        startCursor: (_d = params.startCursor) !== null && _d !== void 0 ? _d : "",
                        isShowAllCustomer: (_e = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.showAllCustomer) !== null && _e !== void 0 ? _e : false,
                        isSaveToStore: (_f = params.isSaveToStore) !== null && _f !== void 0 ? _f : false,
                    })(dispatch)];
                case 1:
                    response = _g.sent();
                    if (response) {
                        updateLocalCompanyState(response);
                    }
                    return [2 /*return*/, response];
            }
        });
    }); };
    /** First page from data=56 — use after mount and when refreshing list (e.g. new company created) */
    var refreshCompanyList = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoading.next(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetchCompanies({ searchQuery: "", isNextPage: true, endCursor: "", startCursor: "", isSaveToStore: true })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error refreshing company list:", error_1);
                    return [3 /*break*/, 5];
                case 4:
                    isLoading.next(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a;
        var cachedCompanies = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.b2bCompaniesData;
        if ((cachedCompanies === null || cachedCompanies === void 0 ? void 0 : cachedCompanies.companies) && cachedCompanies.companies.length > 0) {
            updateLocalCompanyState(cachedCompanies);
            setIsCompanyListLoading(false);
            return;
        }
        (function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsCompanyListLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, refreshCompanyList()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        setIsCompanyListLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var changeCompanySearch = function (e) {
        if (e.target.value) {
            setFilterState(e.target.value);
        }
        else {
            setFilterState("");
            if (currentSearchTerm) {
                handleSearchCompanies();
            }
        }
    };
    var handleKeyPress = function (event) {
        if (event.key === "Enter") {
            handleSearchCompanies(filterState);
        }
    };
    var handleSearchCompanies = function (searchTerm) { return __awaiter(_this, void 0, void 0, function () {
        var error_2, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!searchTerm) return [3 /*break*/, 6];
                    isLoading.next(true);
                    setIsSearching(true);
                    setCurrentSearchTerm(searchTerm.trim());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetchCompanies({ searchQuery: searchTerm.trim(), isNextPage: true, endCursor: "", startCursor: "", isSaveToStore: false })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error("Error searching companies:", error_2);
                    return [3 /*break*/, 5];
                case 4:
                    isLoading.next(false);
                    setIsSearching(false);
                    return [7 /*endfinally*/];
                case 5: return [3 /*break*/, 11];
                case 6:
                    // Clear search — reload first page from data=56
                    setIsSearching(false);
                    setCurrentSearchTerm("");
                    isLoading.next(true);
                    setIsCompanyListLoading(true);
                    _a.label = 7;
                case 7:
                    _a.trys.push([7, 9, 10, 11]);
                    return [4 /*yield*/, fetchCompanies({ searchQuery: "", isNextPage: true, endCursor: "", startCursor: "", isSaveToStore: true })];
                case 8:
                    _a.sent();
                    return [3 /*break*/, 11];
                case 9:
                    error_3 = _a.sent();
                    console.error("Error clearing company search:", error_3);
                    return [3 /*break*/, 11];
                case 10:
                    isLoading.next(false);
                    setIsCompanyListLoading(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var handlePageChange = function (direction) { return __awaiter(_this, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    isLoading.next(true);
                    setIsPagination(true);
                    return [4 /*yield*/, fetchCompanies({
                            isNextPage: direction === "next",
                            endCursor: paginationState.endCursor,
                            startCursor: paginationState.startCursor,
                            searchQuery: currentSearchTerm,
                            isSaveToStore: false,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _a.sent();
                    console.error("Error in pagination:", error_4);
                    return [3 /*break*/, 4];
                case 3:
                    isLoading.next(false);
                    setIsPagination(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCompanyTypeString = function (pageType, company) { return __awaiter(_this, void 0, void 0, function () {
        var sufixId, companyId, resourceNo, response, companyData, error_5;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, , 6]);
                    if (!(pageType === "Update")) return [3 /*break*/, 3];
                    if (!(company === null || company === void 0 ? void 0 : company.companyId)) return [3 /*break*/, 2];
                    setActiveCompanyString((_a = company === null || company === void 0 ? void 0 : company.companyName) !== null && _a !== void 0 ? _a : "-");
                    sufixId = company === null || company === void 0 ? void 0 : company.companyId;
                    companyId = sufixId.trim().split("gid://shopify/Company/")[1];
                    resourceNo = "3";
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(singleCompanyDataService(resourceNo, companyId))];
                case 1:
                    response = _d.sent();
                    isLoading.next(false);
                    if (response === null || response === void 0 ? void 0 : response.b2bCompanyDetails) {
                        companyData = mappedCompanyDetails(response === null || response === void 0 ? void 0 : response.b2bCompanyDetails);
                        setSingleCompanyDetails(companyData);
                        setCompanyCustomerOrderingRoleId((_c = (_b = response === null || response === void 0 ? void 0 : response.b2bCompanyDetails) === null || _b === void 0 ? void 0 : _b.CompanyCustomerOrderingRoleId) !== null && _c !== void 0 ? _c : "");
                    }
                    _d.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    setActiveCompanyString(pageType);
                    _d.label = 4;
                case 4:
                    setIsClicked(!isClicked);
                    return [3 /*break*/, 6];
                case 5:
                    error_5 = _d.sent();
                    return [2 /*return*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var BackBtnAction = function () {
        setIsClicked(!isClicked);
    };
    var mappedCompanyDetails = function (b2bCompanyDetails) {
        var _a, _b, _c, _d, _e;
        return {
            Id: b2bCompanyDetails === null || b2bCompanyDetails === void 0 ? void 0 : b2bCompanyDetails.Id,
            Name: b2bCompanyDetails === null || b2bCompanyDetails === void 0 ? void 0 : b2bCompanyDetails.Name,
            ExternalId: b2bCompanyDetails === null || b2bCompanyDetails === void 0 ? void 0 : b2bCompanyDetails.ExternalId,
            Note: b2bCompanyDetails === null || b2bCompanyDetails === void 0 ? void 0 : b2bCompanyDetails.Note,
            MainContact: b2bCompanyDetails === null || b2bCompanyDetails === void 0 ? void 0 : b2bCompanyDetails.MainContact,
            TaxSettings: {
                TaxExemptions: (_a = b2bCompanyDetails === null || b2bCompanyDetails === void 0 ? void 0 : b2bCompanyDetails.TaxSettings) === null || _a === void 0 ? void 0 : _a.TaxExemptions,
                TaxRegistrationId: (_b = b2bCompanyDetails === null || b2bCompanyDetails === void 0 ? void 0 : b2bCompanyDetails.TaxSettings) === null || _b === void 0 ? void 0 : _b.TaxRegistrationId,
            },
            Contacts: (_c = b2bCompanyDetails === null || b2bCompanyDetails === void 0 ? void 0 : b2bCompanyDetails.Contacts) === null || _c === void 0 ? void 0 : _c.map(function (contact) { return ({
                Id: contact.Id,
                FirstName: contact.FirstName,
                LastName: contact.LastName,
                DisplayName: contact.DisplayName,
                Email: contact.Email,
                Role: contact.Role,
                IsMainContact: contact.IsMainContact,
            }); }),
            Locations: (_d = b2bCompanyDetails === null || b2bCompanyDetails === void 0 ? void 0 : b2bCompanyDetails.Locations) === null || _d === void 0 ? void 0 : _d.map(function (location) {
                var _a, _b, _c, _d;
                return ({
                    Id: location.Id,
                    Name: location.Name,
                    Note: location.Note,
                    ExternalId: location.ExternalId,
                    ContactPersons: (_a = location === null || location === void 0 ? void 0 : location.ContactPersons) === null || _a === void 0 ? void 0 : _a.map(function (ContactPersons) { return ({
                        Id: ContactPersons === null || ContactPersons === void 0 ? void 0 : ContactPersons.Id,
                        DisplayName: ContactPersons === null || ContactPersons === void 0 ? void 0 : ContactPersons.DisplayName,
                        Email: ContactPersons === null || ContactPersons === void 0 ? void 0 : ContactPersons.Email,
                        Role: ContactPersons === null || ContactPersons === void 0 ? void 0 : ContactPersons.Role,
                    }); }),
                    Catalogs: (_b = location === null || location === void 0 ? void 0 : location.Catalogs) === null || _b === void 0 ? void 0 : _b.map(function (catalog) { return ({
                        Id: catalog.Id,
                        Title: catalog.Title,
                        ProductCount: catalog.ProductCount,
                    }); }),
                    ShippingAddress: mapAddress(location === null || location === void 0 ? void 0 : location.ShippingAddress),
                    BillingAddress: mapAddress(location === null || location === void 0 ? void 0 : location.BillingAddress),
                    PaymentTermsTemplateId: location === null || location === void 0 ? void 0 : location.PaymentTermsTemplateId,
                    BuyerExperienceConfiguration: {
                        PaymentTermsId: (_c = location.BuyerExperienceConfiguration) === null || _c === void 0 ? void 0 : _c.PaymentTermsId,
                        PaymentTermsName: (_d = location.BuyerExperienceConfiguration) === null || _d === void 0 ? void 0 : _d.PaymentTermsName,
                    },
                    TaxExempt: location.TaxExempt,
                    TaxRegistrationId: location.TaxRegistrationId,
                });
            }),
            ContactRoles: (_e = b2bCompanyDetails === null || b2bCompanyDetails === void 0 ? void 0 : b2bCompanyDetails.ContactRoles) !== null && _e !== void 0 ? _e : [],
        };
    };
    return {
        t: t,
        orderType: orderType,
        filterState: filterState,
        applyFilter: applyFilter,
        HeaderNames: HeaderNames,
        sortHeaderData: sortHeaderData,
        byColumnName: byColumnName,
        handleCompanyTypeString: handleCompanyTypeString,
        isClicked: isClicked,
        activeCompanyString: activeCompanyString,
        singleCompanyDetails: singleCompanyDetails,
        setActiveLocationString: setActiveLocationString,
        BackBtnAction: BackBtnAction,
        activeLocationString: activeLocationString,
        CompanyCustomerOrderingRoleId: CompanyCustomerOrderingRoleId,
        companyArray: companyArray,
        setCompanyArray: setCompanyArray,
        setSingleCompanyDetails: setSingleCompanyDetails,
        // Pagination & search
        isCompanyListLoading: isCompanyListLoading,
        isSearching: isSearching,
        isPagination: isPagination,
        paginationState: paginationState,
        currentSearchTerm: currentSearchTerm,
        handleSearchCompanies: handleSearchCompanies,
        handlePageChange: handlePageChange,
        changeCompanySearch: changeCompanySearch,
        handleKeyPress: handleKeyPress,
        totalCount: (_c = companyArray === null || companyArray === void 0 ? void 0 : companyArray.length) !== null && _c !== void 0 ? _c : 0,
        refreshCompanyList: refreshCompanyList,
    };
}
export function CssConstants() {
    var ProductTableCSS = {
        padding: "10px",
        fontSize: "12px",
        whiteSpace: "nowrap",
    };
    return ProductTableCSS;
}
